import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";

const CATS = [
  { k: "", label: "All" },
  { k: "face", label: "Face" },
  { k: "hair", label: "Hair" },
  { k: "sun", label: "Sun" },
  { k: "cleanser", label: "Cleanse" },
];

export default function Shop() {
  const [products, setProducts] = useState([]);
  const [params, setParams] = useSearchParams();
  const cat = params.get("cat") || "";
  const q = params.get("q") || "";

  useEffect(() => {
    const qs = {};
    if (cat) qs.cat = cat;
    if (q) qs.q = q;
    api.get("/products", { params: qs }).then((r) => setProducts(r.data));
  }, [cat, q]);

  const filtered = products;

  return (
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-16">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-end mb-12">
        <div className="lg:col-span-8">
          <div className="eyebrow">Shop</div>
          <h1 className="mt-3 font-display text-6xl text-ink-900 leading-none">
            {q ? <>Results for <em className="serif-accent text-gold-500">&quot;{q}&quot;</em></> : "The collection."}
          </h1>
          {q && (
            <button onClick={() => setParams(cat ? { cat } : {})} className="mt-3 text-xs uppercase tracking-widest link-underline" data-testid="clear-search">
              Clear search
            </button>
          )}
        </div>
        <div className="lg:col-span-4 flex flex-wrap gap-2 lg:justify-end">
          {CATS.map((c) => (
            <button
              key={c.k}
              onClick={() => {
                const next = {};
                if (c.k) next.cat = c.k;
                if (q) next.q = q;
                setParams(next);
              }}
              data-testid={`filter-${c.k || "all"}`}
              className={
                "px-5 py-2 text-xs uppercase tracking-widest border transition-colors " +
                (cat === c.k ? "bg-ink-900 text-white border-ink-900" : "hairline text-ink-700 hover:bg-cream-200")
              }
            >
              {c.label}
            </button>
          ))}
        </div>
      </div>

      {filtered.length === 0 && (
        <div className="border hairline p-16 text-center bg-white">
          <div className="font-display text-3xl">No products found.</div>
          <p className="mt-2 text-ink-500 text-sm">Try a different search term or category.</p>
        </div>
      )}

      <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 lg:gap-10">
        {filtered.map((p) => <ProductCard key={p.id} p={p} />)}
      </div>
    </div>
  );
}
